import { Component, EventEmitter, input, model, OnInit, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { LabelComponent } from '../label/label.component';
import { ButtonComponent } from '../button/button.component';
import { Types } from 'shared-lib';
import { EComponentSize, EIcon, ELabelType } from '../../types';
import { helper } from '../../../public-api';

@Component({
  selector: 'ui-alert-popup',
  standalone: true,
  imports: [CommonModule, IconComponent, LabelComponent, ButtonComponent],
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmPopupComponent implements OnInit {
  title = input<string>("Alerta");
  message = input<string>("Mensagem do alerta");
  icon = model<EIcon>(EIcon.Trash);
  type = model<Types.EAlert>(Types.EAlert.DARK);
  
  confirm = output<void>();
  cancel = output<void>();
  close = output<void>();

  EAlert = Types.EAlert;
  EIcon = EIcon;
  EComponentSize = EComponentSize;
  ELabelType = ELabelType;
  darkMode = false;

  ngOnInit(): void {
    this.darkMode = helper.Functions.isDarkMode();
  }

  get containerClasses(): string {
    return this.darkMode
      ? "bg-gray-900 text-white shadow-xl rounded-lg p-6 max-w-lg w-full relative"
      : "bg-white text-gray-900 shadow-xl rounded-lg p-6 max-w-lg w-full relative";
  }
  
}
